import { render, staticRenderFns } from "./Theme2Faq.vue?vue&type=template&id=0b349470&scoped=true&"
import script from "./Theme2Faq.vue?vue&type=script&lang=js&"
export * from "./Theme2Faq.vue?vue&type=script&lang=js&"
import style0 from "./Theme2Faq.vue?vue&type=style&index=0&id=0b349470&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b349470",
  null
  
)

export default component.exports